var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46214 1H8.44782C8.75145 1 9.04454 1.11137 9.27155 1.313L10.5831 2.47795C10.8481 2.71335 10.9998 3.05088 10.9998 3.40535V8.19193C10.9998 8.87699 10.4444 9.43233 9.75939 9.43233H5.46214C4.77709 9.43233 4.22174 8.87699 4.22174 8.19193V2.2404C4.22174 1.55535 4.77709 1 5.46214 1Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77805 9.823V10.5594C7.77805 11.3081 7.17112 11.915 6.42244 11.915H2.35561C1.60693 11.915 1 11.3081 1 10.5594V4.83828C1 4.08959 1.60693 3.48267 2.35561 3.48267H3.91065",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95996 1V3.28629C7.95996 3.56031 8.1821 3.78245 8.45612 3.78245H11.0003",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailcopy);
export default __webpack_public_path__ + "static/media/emailcopy.2466a9fa650e7b101dd4b88426759f06.svg";
export { ForwardRef as ReactComponent };